import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import SubNavPopover from './SubNavPopover';
import utils from '../../../utils';

function UrlDrivenTopNav({ 
            apppath=null, 
            navs=null, 
            fields=null, 
            sendNavItemToShow, 
            item=null,
            activeTab=null,
            subUrlVal=null,
            subItems=null,
            tenantSettings=null,
        }) {
    const [activePopover, setActivePopover] = useState(null)
    const [navToShow, setNavToShow] = useState(null)

    const togglePopover = (nav, popoverId) => {
        setActivePopover((prev) => (prev === popoverId ? null : popoverId));
    };

    useEffect(() => {
        if (apppath && tenantSettings) {
            let pathToDisplay = utils.findURLPath(tenantSettings && tenantSettings.tenant && tenantSettings.tenant.fields && tenantSettings.tenant.fields.apps ? tenantSettings.tenant.fields.apps : '', apppath, false)
            setNavToShow(pathToDisplay);
        }
    }, [apppath, tenantSettings])

    const closePopover = () => {
        setActivePopover(null)
    }

    if(item && subItems) {
        let theSubURLVal
        if(subUrlVal) {
            theSubURLVal = subUrlVal;
        } else {
            theSubURLVal = item.fields.slug;
        }
        apppath = `${navToShow ? navToShow : apppath}/${theSubURLVal}`;
    } 

    return (
        <div className='url-driven-topnav border-bottom-light m-b-end-08 p-i' >
            {

                apppath && navs && navs.length > 0 ? (
                    navs.length === 1 ? (
                        // Handle single navigation item - top level only
                        // If there is only one tab with subnavs it will show the navs as single items across the tab structure
                        navs[0].subNav.map((navItem, index) => {
                            let basePath;
                            if (navToShow) {
                                basePath = !navToShow.includes(subUrlVal) && subUrlVal
                                    ? `${navToShow}/${subUrlVal}`
                                    : navToShow;
                            } else {
                                basePath = subUrlVal
                                    ? (apppath.includes(subUrlVal) ? apppath : `${apppath}/${subUrlVal}`)
                                    : apppath; // prevent /null in path if subUrlVal is null
                            }

                            const finalPath = `/${basePath}/${navItem.urlForField}`;

                            const isTabActive = navItem.subNav?.some((sub) => sub.urlForField === activeTab?.url) || (activeTab?.level_three && navItem.groupingTitle === "Capability Analysis");
                            const showAsActive = activePopover === null && isTabActive;

                            return (
                                <LinkContainer to={finalPath} key={index}>
                                    <Button variant="none" 
                                        className={`tab-nav-btn blueprint-nav-1 ${showAsActive ? 'active-tab' : ''}`}
                                        onClick={() => sendNavItemToShow(apppath,  null)}
                                    >
                                        {navItem.linkLabel}
                                    </Button>
                                </LinkContainer>
                            );
                        })
                    ) : (
                        // If there are multiple tabs with or without subnavs it goes into the SubNavPopover component
                        navs.map((navItem, index) => {
                            // Only show as active if we are actually on a Summary or Company page for that group
                            const isTabActive =
                            activeTab?.title === navItem.groupingTitle ||
                            (activeTab?.level_three && navItem.groupingTitle === "Capability Analysis");

                            // Do NOT show as active just because dropdown is open
                            const showAsActive = isTabActive;
                            const isDropdownOpen = activePopover === index;

                          
                            return (
                              <SubNavPopover
                                key={index}
                                activeTab={activeTab}
                                isActive={isDropdownOpen}
                                showAsActive={showAsActive}
                                togglePopover={(nav) => togglePopover(nav, index)}
                                closePopover={closePopover}
                                sendNavItemToShow={sendNavItemToShow}
                                navList={navItem}
                                apppath={apppath}
                                navItem={navItem.groupingTitle}
                                navLevelThree={
                                  fields?.fields?.capabilityAnalysesbyCompany || null
                                }
                              />
                            );
                          })
                    )
                ) : null
            }
        </div>
    )
}

export default UrlDrivenTopNav;